/* eslint-disable */
// @ts-nocheck
/** THIS FILE IS AUTOMATICALLY GENERATED FROM : https://api-preprod.mazda.co.il/swagger/v1/swagger.json **/

import axios from "../axios"
import * as Mazda from "./MazdaInterfaces"

export const postAccountVerifyUser = (data: Mazda.VerifyUserRequest) =>
  axios.post<Mazda.VerifyUserResponseResponseWrapper>(
    `/api/account/verifyUser`,
    data
  )

export const postAccountGenerateVerificationCode = (
  data: Mazda.GenerateVerificationCodeRequest
) =>
  axios.post<Mazda.GenerateVerificationCodeResponseResponseWrapper>(
    `/api/account/generateVerificationCode`,
    data
  )

export const postAccountRegister = (data: Mazda.ShortRegistrationRequest) =>
  axios.post<Mazda.UserRegistrationResponseResponseWrapper>(
    `/api/account/register`,
    data
  )

export const getAccountGetUserInfo = () =>
  axios.get<Mazda.UserInfoResponseResponseWrapper>(`/api/account/getUserInfo`)

export const postAccountLogout = () =>
  axios.post<Mazda.BooleanResponseWrapper>(`/api/account/logout`)

export const getAppMetaDataShowrooms = () =>
  axios.get<Mazda.ShowRoomSlimDtoListResponseWrapper>(
    `/api/appMetaData/showrooms`
  )

export const getAppMetaDataDynamicContent = () =>
  axios.get<Mazda.DynamicContentDtoResponseWrapper>(
    `/api/appMetaData/dynamicContent`
  )

export const getAppMetaDataSitemap = () =>
  axios.get<Mazda.SiteMapPageDtoResponseWrapper>(`/api/appMetaData/sitemap`)

export const getBannerBanner = (pageId: Mazda.BannerPage) =>
  axios.get<Mazda.BannerDtoResponseWrapper>(`/api/banner/banner`, {
    params: { pageId },
  })

export const postCacheClearCache = (data: Mazda.CacheKeyDto) =>
  axios.post<Mazda.BooleanResponseWrapper>(`/api/cache/clearCache`, data)

export const postCacheClearAllCache = () =>
  axios.post<Mazda.BooleanResponseWrapper>(`/api/cache/clearAllCache`)

export const getCarfleetBanner = () =>
  axios.get<Mazda.BannerWithMobileResponseWrapper>(`/api/carfleet/banner`)

export const getCarfleetSubmitApplication = (
  FirstName: string,
  LastName: string,
  PhoneNumber: string,
  Email: string,
  CompanyName: string,
  Role: string,
  PurposeOfApplication: string,
  Text: string,
  IsMailNotifications: boolean
) =>
  axios.get<Mazda.BooleanResponseWrapper>(`/api/carfleet/submitApplication`, {
    params: {
      FirstName,
      LastName,
      PhoneNumber,
      Email,
      CompanyName,
      Role,
      PurposeOfApplication,
      Text,
      IsMailNotifications,
    },
  })

export const getCarmodelPriceList = () =>
  axios.get<Mazda.CarModelsPriceListPageResponseResponseWrapper>(
    `/api/carmodel/priceList`
  )

export const getCarmodelCalculator = (carModelId: number /* int32 */) =>
  axios.get<Mazda.CarModelFinishingLevelsDtoResponseWrapper>(
    `/api/carmodel/calculator`,
    { params: { carModelId } }
  )

export const getCarmodelGet = (id: number /* int32 */) =>
  axios.get<Mazda.CarModelMainDtoResponseWrapper>(`/api/carmodel/get`, {
    params: { id },
  })

export const getShowroomLobby = () =>
  axios.get<Mazda.CarVideoLobbyMetaDataResponseWrapper>(`/api/showroom/lobby`)

export const getShowroomSearch = (
  categoryId: number /* int32 */,
  carName: string
) =>
  axios.get<Mazda.CarVideoDtoListResponseWrapper>(`/api/showroom/search`, {
    params: { categoryId, carName },
  })

export const getEcommColors = (finishingLevelCode: string) =>
  axios.get<Mazda.ColorDtoDelekComponentDtoListResponseWrapper>(
    `/api/ecomm/colors`,
    { params: { finishingLevelCode } }
  )

export const postContactEcommContact = (data: Mazda.ContactDto) =>
  axios.post<Mazda.BooleanResponseWrapper>(`/api/contact/ecommContact`, data)

export const postContactSubmitInsurance = (data: Mazda.ContactUsDto) =>
  axios.post<Mazda.BooleanResponseWrapper>(`/api/contact/submitInsurance`, data)

export const postContactContact = (data: Mazda.ContactUsDto) =>
  axios.post<Mazda.BooleanResponseWrapper>(`/api/contact/contact`, data)

export const postContactNewsLetter = (data: Mazda.NewsLetterRequest) =>
  axios.post<Mazda.BooleanResponseWrapper>(`/api/contact/NewsLetter`, data)

export const getContactNewsLetter = () =>
  axios.get<Mazda.NewsletterSectionDtoResponseWrapper>(
    `/api/contact/NewsLetter`
  )

export const postContactDriveTestReservation = (
  data: Mazda.DriveTestReservationDto
) =>
  axios.post<Mazda.BooleanResponseWrapper>(
    `/api/contact/driveTestReservation`,
    data
  )

export const getContactFaq = () =>
  axios.get<Mazda.FAQDtoResponseWrapper>(`/api/contact/faq`)

export const getContentPageKeys = () =>
  axios.get<Mazda.StringListResponseWrapper>(`/api/content-page/keys`)

export const getContentPagePageKey = (pageKey: string) =>
  axios.get<Mazda.ContentPageDtoResponseWrapper>(`/api/content-page/${pageKey}`)

export const postDelekIntegratedSyncDelekEcommerceData = () =>
  axios.post<Mazda.BooleanResponseWrapper>(
    `/api/delekIntegrated/syncDelekEcommerceData`
  )

export const postDelekIntegratedSyncServicePlansData = () =>
  axios.post<Mazda.BooleanResponseWrapper>(
    `/api/delekIntegrated/syncServicePlansData`
  )

export const getEcommExtras = (finishingLevelCode: string) =>
  axios.get<Mazda.CarExtraItemDtoDelekComponentDtoListResponseWrapper>(
    `/api/ecomm/extras`,
    { params: { finishingLevelCode } }
  )

export const getEcommFinishingLevelsCode = (code: string) =>
  axios.get<Mazda.FinishingLevelDtoResponseWrapper>(
    `/api/ecomm/finishingLevels/${code}`
  )

export const getEcommFinishingLevels = (modelId: number /* int32 */) =>
  axios.get<Mazda.FinishingLevelEngineDtoListResponseWrapper>(
    `/api/ecomm/finishingLevels`,
    { params: { modelId } }
  )

export const getFooter = () =>
  axios.get<Mazda.FooterContentDtoResponseWrapper>(`/api/footer`)

export const getHomepage = (device: Mazda.DisplayOn) =>
  axios.get<Mazda.HomepageDtoResponseWrapper>(`/api/homepage`, {
    params: { device },
  })

export const getHomepageCarStrip = () =>
  axios.get<Mazda.CarStripDtoResponseWrapper>(`/api/homepage/carStrip`)

export const getLandingPageGetLandingPage = (slug: string) =>
  axios.get<Mazda.LandingPageDtoResponseWrapper>(
    `/api/landingPage/getLandingPage`,
    { params: { slug } }
  )

export const getLandingPageGetAllSlugs = () =>
  axios.get<Mazda.StringListResponseWrapper>(`/api/landingPage/getAllSlugs`)

export const getLandingPageGetAllTitlePositions = () =>
  axios.get<Mazda.ViewDataModelListResponseWrapper>(
    `/api/landingPage/getAllTitlePositions`
  )

export const getLandingPageGetAllTitleSections = () =>
  axios.get<Mazda.ViewDataModelListResponseWrapper>(
    `/api/landingPage/getAllTitleSections`
  )

export const getMenu = () =>
  axios.get<Mazda.MenuResponseResponseWrapper>(`/api/menu`)

export const getEcommModelsId = (id: number /* int32 */) =>
  axios.get<Mazda.CarModelDtoDelekComponentDtoResponseWrapper>(
    `/api/ecomm/models/${id}`
  )

export const getEcommModels = () =>
  axios.get<Mazda.CarModelDtoDelekComponentDtoListResponseWrapper>(
    `/api/ecomm/models`
  )

export const getEcommOrdersId = (id: string /* uuid */) =>
  axios.get<Mazda.OrderStatusResponseResponseWrapper>(`/api/ecomm/orders/${id}`)

export const postEcommOrders = (data: Mazda.CreateOrderRequest) =>
  axios.post<Mazda.CreateOrderResponseResponseWrapper>(
    `/api/ecomm/orders`,
    data
  )

export const putEcommOrders = (data: Mazda.EditOrderRequest) =>
  axios.put<Mazda.CreateOrderResponseResponseWrapper>(`/api/ecomm/orders`, data)

export const postEcommOrdersComplete = (data: Mazda.CompletePaymentRequest) =>
  axios.post<Mazda.CompletePaymentResponseResponseWrapper>(
    `/api/ecomm/orders/complete`,
    data
  )

export const postEcommOrdersShareConfigurator = (
  data: Mazda.ShareConfiguratorRequest
) =>
  axios.post<Mazda.BooleanResponseWrapper>(
    `/api/ecomm/orders/shareConfigurator`,
    data
  )

export const postEcommPaymentRedirectTransaction = (
  data: Mazda.PaymentRedirectRequest
) =>
  axios.post<Mazda.CreditGuardRedirectTransactionDtoResponseWrapper>(
    `/api/ecomm/payment/redirectTransaction`,
    data
  )

export const getBenefitView = (
  serviceCenterName: string,
  benefitId: number /* int32 */,
  licenceNumber: string
) =>
  axios.get<any>(`/BenefitView`, {
    params: { serviceCenterName, benefitId, licenceNumber },
  })

export const getBenefitPdf = (
  serviceCenterName: string,
  benefitId: number /* int32 */,
  licenceNumber: string
) =>
  axios.get<any>(`/BenefitPdf`, {
    params: { serviceCenterName, benefitId, licenceNumber },
  })

export const getEcommPricesLicensingFee = (finishingLevelCode: string) =>
  axios.get<Mazda.LicensingFeeResponseResponseWrapper>(
    `/api/ecomm/prices/licensingFee`,
    { params: { finishingLevelCode } }
  )

export const postEcommPrices = (data: Mazda.TotalCarPriceRequest) =>
  axios.post<Mazda.PriceItemDtoResponseWrapper>(`/api/ecomm/prices`, data)

export const getSeoKey = (key: string) =>
  axios.get<Mazda.SeoMetaDataDtoResponseWrapper>(`/api/seo/${key}`)

export const getServiceCenter = (
  longtitude: number /* double */,
  latitude: number /* double */
) =>
  axios.get<Mazda.ServiceCenterDtoListResponseWrapper>(`/api/serviceCenter`, {
    params: { longtitude, latitude },
  })

export const getServiceCenterId = (id: number /* int32 */) =>
  axios.get<Mazda.SingleServiceCenterDtoResponseWrapper>(
    `/api/serviceCenter/${id}`
  )

export const postServiceCenterContact = (data: Mazda.AppointmentDto) =>
  axios.post<Mazda.BooleanResponseWrapper>(`/api/serviceCenter/contact`, data)

export const getServicePlans = () =>
  axios.get<Mazda.ServicePlansResponseResponseWrapper>(`/api/servicePlans`)

export const getSettingsAll = () =>
  axios.get<Mazda.GeneralSettingDtoListResponseWrapper>(`/api/settings/all`)

export const getShowroomAll = (
  longtitude: number /* double */,
  latitude: number /* double */
) =>
  axios.get<Mazda.ShowRoomDtoListResponseWrapper>(`/api/showroom/all`, {
    params: { longtitude, latitude },
  })

export const getEcommUpholsteries = (
  finishingLevelCode: string,
  colorCode: string
) =>
  axios.get<Mazda.UpholsteryDtoDelekComponentDtoListResponseWrapper>(
    `/api/ecomm/upholsteries`,
    { params: { finishingLevelCode, colorCode } }
  )
